/* Coria · trecere UX favorite + compara: nume accesibile in dialogul #coria-catalog (coria-catalog-pro.js il re-randeaza
   la fiecare schimbare, deci reaplicam la fiecare mutatie, cu intarziere scurta). Doar atribute, nimic vizual.
   - comparatie: „Elimina” / „Salveaza in lista” / „Varianta” primesc numele produsului din coloana;
     antetele de rand primesc scope="row"; containerul de derulare primeste tabindex=0 + eticheta (derulare din tastatura);
   - liste: „Elimina” primeste numele produsului; cantitatea avea ca nume handle-ul („polygel-professional-…”) -> titlul. */
(function () {
  'use strict';
  if (window.__cfUxSalvate) return; window.__cfUxSalvate = 1;
  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function setLabel(el, v) { if (el && v && el.getAttribute('aria-label') !== v) el.setAttribute('aria-label', v); }

  function apply(d) {
    // comparatie
    var table = d.querySelector('.cp-table-scroll table');
    if (table && table.rows.length) {
      var head = table.rows[0];
      for (var c = 1; c < head.cells.length; c++) {
        var cell = head.cells[c], name = txt(cell.querySelector('a'));
        if (!name) continue;
        [].forEach.call(cell.querySelectorAll('button'), function (b) {
          var t = txt(b);
          if (/^Elimin/i.test(t)) setLabel(b, 'Elimină ' + name + ' din comparație');
          else if (/^Salvea/i.test(t)) setLabel(b, 'Salvează ' + name + ' în listă');
        });
        var sel = cell.querySelector('select');
        if (sel) setLabel(sel, 'Varianta pentru ' + name);
      }
      for (var r = 1; r < table.rows.length; r++) {
        var th = table.rows[r].cells[0];
        if (th && th.tagName === 'TH' && !th.hasAttribute('scope')) th.setAttribute('scope', 'row');
      }
      var sc = d.querySelector('.cp-table-scroll');
      if (sc && !sc.hasAttribute('tabindex')) {
        sc.setAttribute('tabindex', '0');
        sc.setAttribute('role', 'region');
        sc.setAttribute('aria-label', txt(table.caption) || 'Tabel de comparatie');
      }
    }
    // liste de favorite
    [].forEach.call(d.querySelectorAll('.cp-list li'), function (li) {
      var name = txt(li.querySelector('a'));
      if (!name) return;
      [].forEach.call(li.querySelectorAll('button'), function (b) {
        if (/^Elimin/i.test(txt(b))) setLabel(b, 'Elimină ' + name + ' din listă');
      });
      var q = li.querySelector('input[type="number"]');
      if (q) setLabel(q, 'Cantitate dorită pentru ' + name);
    });
  }

  var t = 0;
  function watch(d) {
    if (d.dataset.uxSalvate) return; d.dataset.uxSalvate = '1';
    apply(d);
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = 0; apply(d); }, 60);
    }).observe(d, { childList: true, subtree: true });
  }
  function find() { var d = document.getElementById('coria-catalog'); if (d) watch(d); return !!d; }
  // dialogul e creat de coria-catalog-pro.js direct in <body> (uneori abia la prima deschidere):
  // observam doar copiii directi ai lui body si ne oprim cand apare
  function start() {
    if (find() || !window.MutationObserver) return;
    var mo = new MutationObserver(function () { if (find()) mo.disconnect(); });
    mo.observe(document.body, { childList: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
